<template>
  <div>
    <PageHeader :title="headerTitle" no-padding />
    <v-card>
      <v-card-actions wrap class="card-bg-2 py-0 layout wrap">
        <DownloadReport @loading="loading.report = $event" :disabled="false" :reportParams="reportParams" :reportName="headerTitle" />
      </v-card-actions>
      <v-divider />

      <v-card-title class="headline pb-0">Report Type</v-card-title>
      <v-card-text class="py-0">
        <v-radio-group v-model="reportParams.reportType" :disabled="loading.report" row>
          <template v-for="reportType in availableReportTypes">
            <v-radio class="mr-4" color="info" :key="reportType.value" :label="reportType.text" :value="reportType.value" />
          </template>
        </v-radio-group>
      </v-card-text>

      <v-card-title class="headline pb-0">Date Range</v-card-title>
      <v-card-text class="py-0" style="max-width: 600px;">
        <DateRange ref="dateRange" v-model="dates" :disabled="loading.report" hideClear @update:selectedRange="updateSelectedRange($event)" :relativeDate="dates.start" rounded solo :maxDate="maxDate" :shortcuts="reportShortcuts" :selectedRange="selectedRange" no-arrows :includeDefaultShortcuts="false" :calculateSelectedRange="false" />
      </v-card-text>

      <v-card-title class="headline pb-0">Include QA/QC sample data</v-card-title>
      <v-card-text class="py-0">
        <v-radio-group v-model="reportParams.includeQaQc" :disabled="loading.report" row>
          <v-radio class="mr-4" color="info" label="Yes" :value="true" />
          <v-radio class="mr-4" color="info" label="No" :value="false" />
        </v-radio-group>
      </v-card-text>
<!-- 
      <v-card-title class="headline pb-0">Include data gaps</v-card-title>
      <v-card-text class="py-0">
        <v-radio-group v-model="reportParams.includeGapMarkers" :disabled="loading.report" row>
          <v-radio class="mr-4" color="info" label="Yes" :value="true" />
          <v-radio class="mr-4" color="info" label="No" :value="false" />
        </v-radio-group>
      </v-card-text> -->
    </v-card>
  </div>
</template>

<script>
  import moment from 'moment'
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import { backendDateTimeFormat, formatDate } from '@/components/mixins/MomentUtil'

  import DownloadReport from './Actions/DownloadReport'

  const authenticate = createNamespacedHelpers('authenticate')

  const reportTypes = {
    groundwater: {
      text: 'Groundwater',
      value: 'Groundwater',
    },
    surfaceAndProcessWater: {
      text: 'Surface and Process Water',
      value: 'Surface_process_water',
    },
    surfaceAndProcessWaterWithBCWQG: {
      text: 'Surface and Process Water with BC WQG',
      value: 'Surface_process_water_with_bc_wqg',
    },
  }

  const b2GoldreportTypes = {
    surfaceWater: {
      text: 'Surface Water',
      value: 'surface-water',
    },
    nwbInternal: {
      text: 'NWB Internal',
      value: 'nwb-internal',
    },
    nwbExternal: {
      text: 'NWB External',
      value: 'nwb-external',
    },
  }

  /* eslint-disable no-unused-vars */
  const dateRangeShortcuts = {
    monthly: {
      key: 'Monthly',
      index: 2,
      name: () => 'Monthly',
      make: (start, end) => {
        return {
          start: start.clone(),
          end: start.clone().add(1, 'months').subtract(1, 'day'),
        }
      },
      increment: (start, end) => {
        return {
          start: start.clone().add(1, 'months'),
          end: start.clone().add(2, 'months').subtract(1, 'day'),
        }
      },
      decrement: (start, end) => {
        return {
          start: start.clone().add(-1, 'months'),
          end: start.clone().subtract(1, 'day'),
        }
      },
    },
    quarterly: {
      key: 'Quarterly',
      index: 3,
      name: () => 'Quarterly',
      make: (start, end) => {
        return {
          start: start.clone().add(-2, 'months'),
          end: start.clone().add(1, 'months').subtract(1, 'day'),
        }
      },
      increment: (start, end) => {
        return {
          start: start.clone().add(1, 'months'),
          end: start.clone().add(4, 'months').subtract(1, 'day'),
        }
      },
      decrement: (start, end) => {
        return {
          start: start.clone().add(-1, 'months'),
          end: start.clone().add(2, 'months').subtract(1, 'day'),
        }
      },
    },
  }
  /* eslint-enable no-unused-vars */

  export default {
    components: {
      DownloadReport,
    },
    data: () => ({
      reportTypes,
      maxDate: new Date(),
      dates: {
        start: moment().subtract(1, 'months').startOf('month').toDate(),
        end: moment().subtract(1, 'months').endOf('month').toDate(),
      },
      reportParams: {
        reportType: null,
        startDate: null,
        endDate: null,
        includeQaQc: false,
        includeGapMarkers: false,
      },
      selectedRange: dateRangeShortcuts.monthly,
      loading: {
        report: false,
      },      
    }),
    computed: {
      ...authenticate.mapGetters(['currentUserGroup']),
      reportShortcuts() {
        return dateRangeShortcuts
      },
      availableReportTypes() {
        if(this.currentUserGroup && this.currentUserGroup.name == 'b2gold_back') {
          return b2GoldreportTypes
        } else {
          return reportTypes
        }
      },
      headerTitle() {
        if(this.currentUserGroup && this.currentUserGroup.name == 'b2gold_back') {
          return 'NWB Monthly Report'
        } else {
          return 'BC MOE Report' //user the default router header
        }
      },
    },
    watch: {
      dates: {
        immediate: true,
        handler(val) {
          this.reportParams.startDate = formatDate(val.start, backendDateTimeFormat)
          this.reportParams.endDate = formatDate(val.end, backendDateTimeFormat)
        },
      },
      currentUserGroup: {
        immediate: true,
        handler(val) {
          if(val) {
            var key = Object.keys(this.availableReportTypes)[0]
            this.reportParams.reportType = this.availableReportTypes[key].value
          }
        },
      },
    },
    methods: {
      updateSelectedRange(rangeSelected) {
        this.selectedRange = rangeSelected
      },
    },
  }
</script>